import { apiClient } from './client';
import type {
  Export,
  ExportType,
  CreateExportData,
  CreateExportResponse,
} from '@/types/admin-export';

export async function getExportTypes(): Promise<ExportType[]> {
  const response = await apiClient.get<ExportType[]>('/api/admin/exports/types');
  return response.data;
}

export async function getExports(): Promise<Export[]> {
  const response = await apiClient.get<Export[]>('/api/admin/exports');
  return response.data;
}

export async function createExport(data: CreateExportData): Promise<CreateExportResponse> {
  const response = await apiClient.post<CreateExportResponse>('/api/admin/exports', data);
  return response.data;
}

export async function getExportStatus(id: number): Promise<Export> {
  const response = await apiClient.get<Export>(`/api/admin/exports/${id}`);
  return response.data;
}

export async function processExport(id: number): Promise<Export> {
  const response = await apiClient.post<Export>(`/api/admin/exports/${id}/process`);
  return response.data;
}

export async function deleteExport(id: number): Promise<{ message: string }> {
  const response = await apiClient.delete<{ message: string }>(`/api/admin/exports/${id}`);
  return response.data;
}

export function getExportDownloadUrl(id: number): string {
  const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8092';
  return `${baseUrl}/api/admin/exports/${id}/download`;
}
